import { Box, Typography } from "@mui/material";

export default function ErrorPane({ error }: { error?: string }) {
  return (
    <>
      {error && (
        <Box
          p={2}
          borderRadius={1}
          bgcolor={(theme) => theme.palette.error.alpha12}
        >
          <Typography color="error">{error}</Typography>
        </Box>
      )}
    </>
  );
}
